import { Building2, Network, TrendingUp, Rocket, Calculator, Briefcase } from "lucide-react";
import { Container, PageHero, SectionLabel, CtaBand } from "./_ui";
import { Seo } from "@/components/marketing/Seo";

const AUDIENCES = [
  { icon: Building2, title: "Aksjeselskap", desc: "Ett samlet styrerom for det norske AS-et — fra første protokoll til neste emisjon." },
  { icon: Network, title: "Konsern", desc: "Morselskap og datterselskaper i én portefølje, med felles oversikt over møter og tall." },
  { icon: TrendingUp, title: "Investorer", desc: "Følg eierposter, verdiutvikling og avtaler på tvers av alle selskapene du sitter i." },
  { icon: Rocket, title: "Oppstart", desc: "Cap table, opsjoner og emisjoner uten regneark — ryddig fra første investorrunde." },
  { icon: Calculator, title: "Regnskapsfører", desc: "Bistå kundenes styrer med tallene du allerede fører, uten dobbeltarbeid." },
  { icon: Briefcase, title: "Rådgiver", desc: "Kjør transaksjoner og aksjekjøpsavtaler for flere klienter i samme arbeidsflate." },
];

const STEPS = [
  { n: "01", title: "Legg til selskapene", desc: "Hent selskapsdata fra Brønnøysund og Proff, og inviter styret inn med riktige roller." },
  { n: "02", title: "Koble til regnskapet", desc: "Én integrasjon mot regnskapssystemet gir ferske tall uten manuelle rapporter." },
  { n: "03", title: "Styr i sanntid", desc: "Møter, avtaler, transaksjoner og oppgaver følges opp fra én porteføljeoversikt." },
];

export default function ForHvem() {
  return (
    <>
      <Seo title="For hvem" description="Murphy Styrerom passer for aksjeselskaper, konsern, investorer, oppstartsselskaper, regnskapsførere og rådgivere som følger opp flere styrer." path="/for-hvem" />
      <PageHero label="For hvem" title="Fra ett styre til hele porteføljen.">
        Samme styrerom, uansett om du sitter i ett styre eller følger opp tjue selskaper.
      </PageHero>

      <Container className="py-10">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {AUDIENCES.map((a) => (
            <div key={a.title} className="rounded-2xl border border-neutral-200 p-7 transition-colors hover:border-neutral-900">
              <div className="grid h-11 w-11 place-items-center rounded-xl bg-[#CDF546]"><a.icon className="h-5 w-5 text-neutral-900" strokeWidth={1.9} /></div>
              <h3 className="mt-5 font-headings text-lg font-bold text-neutral-900">{a.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-neutral-600">{a.desc}</p>
            </div>
          ))}
        </div>
      </Container>

      <Container className="py-12 sm:py-16">
        <SectionLabel>Slik fungerer det</SectionLabel>
        <div className="mt-10 grid gap-8 sm:grid-cols-3">
          {STEPS.map((s) => (
            <div key={s.n}>
              <span className="font-headings text-4xl font-extrabold tracking-tight text-[#9bb800]">{s.n}</span>
              <h3 className="mt-3 font-headings text-lg font-bold text-neutral-900">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-neutral-600">{s.desc}</p>
            </div>
          ))}
        </div>
      </Container>

      <CtaBand />
    </>
  );
}
